import React from 'react'
import Slider from 'react-slick'
import { makeStyles, CircularProgress } from '@material-ui/core'
import moment from 'moment'
import UserAvatar from '../shared/UserAvatar'

const useStyles = makeStyles(theme => ({
  infirmary_slider_root: {
    paddingBottom: 25,
    overflow: 'hidden',
    '& .slick-slide': {
      padding: '0px 10px',
      width: 300
    },
    '& .slick-list': {
      width: '100%',
      margin: '0px -10px'
    }
  },
  title: {
    color: '#386093',
    marginTop: 0
  },
  answer_card: {
    cursor: 'pointer',
    borderRadius: 16,
    padding: '32px 16px',
    minHeight: 400
  },
  last_answer_color: {
    color: '#FFFFFF',
    backgroundColor: '#EF7C8F'
  },
  answer_color: {
    color: '#555555',
    backgroundColor: '#FFFFFF'
  },
  user_infos: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& .name': {
      fontSize: 18,
      margin: 0
    },
    '& .classroom': {
      fontSize: 14,
      margin: 0
    }
  },
  parent_info: {
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    '& .parent_label, .parent_name, .parent_phone': {
      margin: 0
    },
    '& .parent_label': {
      fontSize: 12
    },
    '& .parent_name, .parent_phone, .parent_email': {
      fontSize: 14
    },
    '& .parent_email': {
      wordBreak: 'break-all'
    }
  },
  avatar_section: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 4
  },
  symptom_description: {
    wordBreak: 'break-word'
  }
}))

const InfirmarySlider = ({
  getReportStudentsAnswers,
  reportAnswers,
  history
}) => {
  const classes = useStyles()
  const [isDragging, setIsDragging] = React.useState(false)
  React.useEffect(() => {
    getReportStudentsAnswers({
      params: {
        'q[tag_tag_order_eq]': 25,
        'page[size]': 6,
        'q[s]': 'created_at desc'
      }
    })
  }, [])

  const lastAnswer = React.useMemo(
    () => {
      if (reportAnswers.items?.length > 0) {
        const now = new Date()
        return reportAnswers?.items.reduce((prev, curr) => {
          const prevDiff = Math.abs(new Date(prev.created_at) - now)
          const currDiff = Math.abs(new Date(curr.created_at) - now)
          return currDiff < prevDiff ? curr : prev
        })
      }
    },
    [reportAnswers]
  )

  const handleClickItem = (e, answerId) => {
    if (isDragging) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    console.warn(`answer ${answerId}`)
  }

  if (reportAnswers?.isFetching) {
    return (
      <div className={classes.infirmary_slider_root}>
        <CircularProgress />
      </div>
    )
  }
  return (
    <div className={classes.infirmary_slider_root}>
      <h1 className={classes.title}>Enfermaria</h1>
      <Slider
        dots
        infinite={false}
        adaptiveHeight
        variableWidth
        slidesToShow={1}
        slidesToScroll={1}
        beforeChange={() => setIsDragging(true)}
        afterChange={() => setIsDragging(false)}
        responsive={[
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide: 1
            }
          }
        ]}
      >
        {reportAnswers?.items.length > 0 &&
          reportAnswers?.items.map(answer => {
            const symptoms = answer.multiple_answers.join('; ')
            const answerDate = moment(answer.created_at).format('DD/MM/YYYY')
            const answerHour = moment(answer.created_at).format('HH:mm')
            return (
              <div
                key={answer.id}
                onClick={event => handleClickItem(event, answer.id)}
                className={`${classes.answer_card} ${
                  lastAnswer?.id === answer.id
                    ? classes.last_answer_color
                    : classes.answer_color
                }`}
              >
                <p className={classes.answer_date}>
                  {answerDate} - {answerHour}
                </p>
                <div className={classes.avatar_section}>
                  <UserAvatar
                    avatarStyle={{ width: 56, height: 56, borderRadius: 16 }}
                    avatarUrl={answer?.report_student?.child?.avatar_url}
                    userName={answer?.report_student?.child?.name}
                    withoutUserName
                  />
                  <div className={classes.user_infos}>
                    <h1 className='name'>
                      {answer.report_student.child?.name}
                    </h1>
                    <p className='classroom'>
                      {
                        answer.report_student.report.report_template
                          .classroom?.[0].name
                      }
                    </p>
                  </div>
                </div>
                <div className={classes.parent_info}>
                  <p className='parent_label'>Responsável</p>
                  <p className='parent_name'>
                    {answer.report_student.child?.parents?.[0]?.name}
                  </p>
                  {answer.report_student.child?.parents?.[0]?.phone && (
                    <p className='parent_phone'>
                      {answer.report_student.child.parents[0].phone}
                    </p>
                  )}
                  {answer.report_student.child?.parents?.[0]?.email && (
                    <p className='parent_email'>
                      {answer.report_student.child.parents[0].email}
                    </p>
                  )}
                </div>
                <p>
                  <i>{symptoms}</i>
                </p>
                <p className={classes.symptom_description}>{answer.answer}</p>
              </div>
            )
          })}
      </Slider>
    </div>
  )
}

export default InfirmarySlider
